<script async setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import FavoritesService, { FAVORITES_EVENT } from "../services/FavoritesService.js";

const props = defineProps({
    emptyText: {
        type: String,
        default: "",
    }
});

const products = ref([]);
const loading = ref(true);

const loadProducts = async () => {
    const ids = FavoritesService.getAll();

    if (!ids.length) {
        products.value = [];
        loading.value  = false;
        return;
    }

    try {
        const url  = `/wp-json/kd/v1/favorites-products?ids=${encodeURIComponent(ids.join(","))}`;
        const resp = await fetch(url, { credentials: "same-origin" });

        if (!resp.ok) {
            throw new Error(`HTTP ${resp.status}`);
        }

        products.value = await resp.json();
    } catch (e) {
        console.error("KD Favorites: Fehler beim Laden", e);
        products.value = [];
    } finally {
        loading.value = false;
    }
};

const onFavoritesChanged = async () => {
    loading.value = true;
    await loadProducts();
};

onMounted(async () => {
    await loadProducts();

    if (typeof window !== "undefined") {
        window.addEventListener(FAVORITES_EVENT, onFavoritesChanged);
    }
});

onBeforeUnmount(() => {
    if (typeof window !== "undefined") {
        window.removeEventListener(FAVORITES_EVENT, onFavoritesChanged);
    }
});
</script>

<template>
    <div>
        <div v-if="loading" class="flex justify-center py-4">
            <kd-icon-loading
                fill="black"
                size="60"
                class="inline-block animate-spin"
            />
        </div>

        <div v-else-if="!products.length" class="text-center py-10 text-black/80">
            {{ props.emptyText }}
        </div>

        <ul v-else class="list-none pb-1 grid grid-cols-1 lg:grid-cols-2 mini:grid-cols-3 book:grid-cols-4 gap-7">
            <li v-for="product in products" :key="product.id">
                <kd-product
                    :product-data="product"
                    variant="small"
                    class="rounded-b-xl"
                >
                </kd-product>
            </li>
        </ul>
    </div>
</template>